





































import { Component, Prop, Vue } from "vue-property-decorator";
import PageTitle from "@/components/PageTitle.vue";

@Component({
	components: {
		"page-title": PageTitle,
	},
})
export default class PageHeader extends Vue {
	@Prop({ required: true })
	pageTitle!: string;

	@Prop({ required: false })
	pageSubtitle!: string;

	@Prop({ required: false })
	pageActionText: string | undefined;

	@Prop({ required: false, default: false })
	disablePageAction!: boolean;

	@Prop({ required: false, default: false })
	pageActionLoading!: boolean;

	@Prop({ required: false })
	goBackText!: string;

	@Prop({ required: false, default: false })
	narrow!: boolean;

	@Prop({ required: false })
	pageSuperTitle!: string;

	mounted() {
		// const stickyElm = document.getElementById("page-header");
		// const observer = new IntersectionObserver(
		//   ([e]) =>
		//     e.target.classList.toggle("elevation-2", e.intersectionRatio < 1),
		//   { threshold: [1] }
		// );
		// observer.observe(stickyElm as any);
	}
}
